import { render, staticRenderFns } from "./Directory.vue?vue&type=template&id=2b33a18f&scoped=true&"
import script from "./Directory.vue?vue&type=script&lang=js&"
export * from "./Directory.vue?vue&type=script&lang=js&"
import style0 from "./Directory.vue?vue&type=style&index=0&id=2b33a18f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33a18f",
  null
  
)

export default component.exports